import { ContactSection } from '@/layout/ContactSection';
import { Footer } from '@/layout/Footer';
import { Nav } from '@/layout/Nav';
import { GlobalStyles, theme } from '@/layout/styles/GlobalStyles';
import { ThemeProvider } from '@emotion/react';
import { SkipNavContent } from '@reach/skip-nav';

import { ReactNode } from 'react';

export const DefaultLayout = ({ children }: { children: ReactNode }) => {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <Nav />
            <SkipNavContent />
            <main>{children}</main>
            <ContactSection />
            <Footer />
        </ThemeProvider>
    );
};
